module.exports = __webpack_public_path__ + "img/clients1-479.ec03975.png";